import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';

@jsonObject
export class AdminShippingMethodPriceRequest {
  @jsonMember(String)
  public readonly countryId!: Guid;

  @jsonMember(String)
  public readonly price!: string;

  @jsonArrayMember(String)
  public readonly paymentMethods!: Guid[];

  public constructor(
    private readonly data: {
      countryId: Guid;
      paymentMethods: Guid[];
      price: string;
    },
  ) {
    this.countryId = this.data.countryId;
    this.paymentMethods = this.data.paymentMethods;
    this.price = this.data.price;
  }
}
